/**
 * GIWAHS Adaptive Journey Core Engine — JourneyLifecycle (AJIP-16.02.003 · WS4)
 * ---------------------------------------------------------------------
 * Central lifecycle event vocabulary. No journey may implement its own
 * lifecycle framework. Every lifecycle boundary in the Core Engine is
 * dispatched through this table.
 */

const LIFECYCLE_EVENTS = Object.freeze({
  INIT: 'INIT',
  ENTRY: 'ENTRY',
  PROGRESSION: 'PROGRESSION',
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
  COMPLETION: 'COMPLETION',
  EXIT: 'EXIT',
  RECOVERY: 'RECOVERY',
});

const ALL_LIFECYCLE_EVENTS = Object.freeze(Object.values(LIFECYCLE_EVENTS));

const isValidLifecycleEvent = (candidate) => ALL_LIFECYCLE_EVENTS.includes(candidate);

export { LIFECYCLE_EVENTS, ALL_LIFECYCLE_EVENTS, isValidLifecycleEvent };
